module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/operations.54e0d4ac.svg";